// extracted by mini-css-extract-plugin
module.exports = {"friends":"Friends_friends__1-Zf7","friends__item":"Friends_friends__item__3Xml3","poster":"Friends_poster__3OVcm","friends__title":"Friends_friends__title__2rx_H"};